import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_TotalCount = _resolveComponent("TotalCount");
    const _component_Item = _resolveComponent("Item");
    const _component_v_data_table_server = _resolveComponent("v-data-table-server");
    const _component_brg_pagination = _resolveComponent("brg-pagination");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_TotalCount, null, {
            default: _withCtx(() => [
                _createTextVNode(" 총 " + _toDisplayString(_ctx.getterCurrentStatusCodeTotal) + " 건 ", 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }),
        _createVNode(_component_v_data_table_server, {
            hover: "",
            class: "brg-table delivery-history-table",
            headers: _ctx.tableHeaders,
            items: _ctx.getterDeliveryHistoryList,
            "items-per-page": _ctx.getterPageSize,
            "fixed-header": "",
            "hide-default-footer": "",
            "multi-sort": "",
            options: _ctx.options,
            "items-length": -1,
            "no-data-text": _ctx.$t(`common.no_search_data_text`),
            density: "compact"
        }, {
            [`item`]: _withCtx(({ item }) => [
                _createVNode(_component_Item, { order: item }, null, 8 /* PROPS */, ["order"])
            ]),
            bottom: _withCtx(() => _cache[1] || (_cache[1] = [])),
            _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["headers", "items", "items-per-page", "options", "no-data-text"]),
        _createVNode(_component_brg_pagination, {
            modelValue: _ctx.page,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.page) = $event)),
            length: _ctx.getterPaginationData.pages
        }, {
            start: _withCtx(() => _cache[2] || (_cache[2] = [])),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue", "length"])
    ]));
}
